import {validations as EquityValidations, defaultValues as EquityDefault} from './Equity';
import {validations as BondsValidations, defaultValues as BondsDefault} from './Bonds';
import {validations as OptionsValidations, defaultValues as OptionsDefault} from './Options';
import {validations as MFundsValidations, defaultValues as MFundsDefault} from './MFunds';
import {validations as ForexValidations, defaultValues as ForexDefault} from './Forex';
import {validations as MMarketValidations, defaultValues as MMarketDefault} from './MMarket';
import {validations as RepoValidations, defaultValues as RepoDefault} from './Repo';
import {validations as FutureValidations, defaultValues as FutureDefault} from './Future';

export {default as Bonds} from './Bonds';
export {default as Equity} from './Equity';
export {default as Options} from './Options';
export {default as MFunds} from './MFunds';
export {default as Forex} from './Forex';
export {default as MMarket} from './MMarket';
export {default as Repo} from './Repo';
export {default as Future} from './Future';

export const formProps = {
	Equity: {
		validation: EquityValidations,
		defaults: EquityDefault
	},
	Bonds: {
		validation: BondsValidations,
		defaults: BondsDefault
	},
	Options: {
		validation: OptionsValidations,
		defaults: OptionsDefault
	},
	'Mutual Funds': {
		validation: MFundsValidations,
		defaults: MFundsDefault
	},
	Forex: {
		validation: ForexValidations,
		defaults: ForexDefault
	},
	'Money Market': {
		validation: MMarketValidations,
		defaults: MMarketDefault
	},
	Repo: {
		validation: RepoValidations,
		defaults: RepoDefault
	},
	Future: {
		validation: FutureValidations,
		defaults: FutureDefault
	},
}

